import { RouteObject } from 'react-router-dom';

import { Invoices } from 'pages/Reports/Invoices';
import { Manager } from 'pages/Reports/Manager';
import { ReportsMain } from 'pages/Reports';
import { JobNumber } from 'pages/Reports/JobNumber';
import { Measurement } from 'pages/Reports/Measurement';
import { Cancelled } from 'pages/Reports/Cancelled';
import { CashFlow } from 'pages/Reports/CashFlow';
import { IncomesAndExpenses } from 'pages/Reports/IncomesAndExpenses';
import { TaxTypes } from 'pages/Reports/TaxTypes';
import { SaleTypes } from 'pages/Reports/SaleTypes';
import { ReportsCreditors } from 'pages/Reports/reportsCreditor';
import { BankTransfer } from 'pages/Reports/BankTransfer';
import { ReportsDebitors } from 'pages/Reports/reportsDebitor';
import CustomerDebitorBalance from 'pages/Reports/CustomerDebitorBalance';
import CustomerCreditorBalance from 'pages/Reports/CustomerCreditorBalance';

import PrivateRoute from '../hoc/PrivateRoute';

export const reportsRoutes: RouteObject[] = [
  {
    path: '/reports',
    element: (
      <PrivateRoute>
        <ReportsMain />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/invoices',
    element: (
      <PrivateRoute>
        <Invoices />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/manager',
    element: (
      <PrivateRoute>
        <Manager />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/job-number',
    element: (
      <PrivateRoute>
        <JobNumber />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/measurement',
    element: (
      <PrivateRoute>
        <Measurement />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/cancelled',
    element: (
      <PrivateRoute>
        <Cancelled />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/cash-flow',
    element: (
      <PrivateRoute>
        <CashFlow />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/customer-balance/debitor',
    element: (
      <PrivateRoute>
        <CustomerDebitorBalance />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/customer-balance/creditor',
    element: (
      <PrivateRoute>
        <CustomerCreditorBalance />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/creditors/:id',
    element: (
      <PrivateRoute>
        <ReportsCreditors />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/debitors/:id',
    element: (
      <PrivateRoute>
        <ReportsDebitors />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/incomes-expences',
    element: (
      <PrivateRoute>
        <IncomesAndExpenses />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/tax-types',
    element: (
      <PrivateRoute>
        <TaxTypes />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/sale-types',
    element: (
      <PrivateRoute>
        <SaleTypes />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/bank-transfer',
    element: (
      <PrivateRoute>
        <BankTransfer />
      </PrivateRoute>
    ),
  },
  {},
];
